<template>
	<BaseLayout :footer-full="true" :include-padding="false" :background-color-class="'bg-color-white'">
		<MarketingPageHeader :header="pageHeader" />
		<BasePlaceHolder :placehold="isLoading" :section-count="8" class="container mt-300 mb-400">
			<AssetElementContainer :asset-elements="assetElements" :use-icon-view-options="true" />
		</BasePlaceHolder>
		<CTABanner />
	</BaseLayout>
</template>
<script setup lang="ts">
import { Asset } from 'types/assets';
import AssetElementContainer from '@components/asset-element/asset-element-container.vue';
import CTABanner from '@components/layout/cta-banner.vue';
import { getAssets } from '@api/sanity/proxy/assets';
import { LandingPageHeader } from 'types/layout';
import MarketingPageHeader from '@components/marketing-site/marketing-page-header.vue';
import { ref } from 'vue';
import { useHead } from '@unhead/vue';

const isLoading = ref(true);

const assetElements = ref<Array<Asset>>([]);

const pageHeader: LandingPageHeader = {
	heading: 'Real Estate Assets',
	summary: [`Fundrise offers unprecedented transparency into what you actually own.`]
};

async function setup(): Promise<void> {
	const metaTitle = 'Real Estate Assets';
	const metaDescription =
		'Browse past and current Fundrise real estate assets, and their projected returns. Explore the portfolio powering our nationwide investment strategy.';

	useHead({
		title: metaTitle,
		meta: [
			{ property: 'og:title', content: metaTitle },
			{ name: 'description', content: metaDescription },
			{ property: 'og:description', content: metaDescription }
		]
	});
	try {
		const realEstateAssets = await getAssets({ elementType: 'REAL_ESTATE' });
		assetElements.value = realEstateAssets.results;
	} catch {
	} finally {
		isLoading.value = false;
	}
}
setup();
</script>
